module.exports = __webpack_public_path__ + "img/PL10003.c68a6d0c.png";